import { CLEAR_INCENTIVE_VALIDATION_ERROR, SET_INCENTIVE_VALIDATION_ERROR } from '../actionTypes/incentivesActionTypes';
import type { IncentiveValidationState } from '../types/incentiveValidationState';

const initialState: IncentiveValidationState = {
    errorMessage: '',
    hasErrors: false
};

export const incentiveValidationReducer = (state = initialState, action: any): IncentiveValidationState => {
    switch (action.type) {
        case SET_INCENTIVE_VALIDATION_ERROR:
            return {
                ...state,
                errorMessage: action.payload.errorMessage,
                hasErrors: action.payload.hasErrors
            };
        case CLEAR_INCENTIVE_VALIDATION_ERROR:
            return initialState;
        default:
            return state;
    }
};

export type IncentiveValidationReducer = typeof incentiveValidationReducer;
